import { render, staticRenderFns } from "./WeekAlldayItem.vue?vue&type=template&id=238d55e6"
import script from "./WeekAlldayItem.ts?vue&type=script&lang=ts&external"
export * from "./WeekAlldayItem.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports